import { GET_PEOPLE_SKILLS } from '@pkg/entities/library/skills/usePeopleSkills';
import useMutation from '@pkg/graphql/useMutation';

const UPDATE_PERSON = /* GraphQL */ `
  mutation UpdatePerson($input: UpdatePersonInput!) {
    updatePerson(input: $input) {
      uuid
    }
  }
`;

export default function useUpdate(query) {
  const { mutateAsync } = useMutation({
    mutation: UPDATE_PERSON,
    invalidateQueries: [query, GET_PEOPLE_SKILLS],
  });

  /**
   * @param {String} uuid
   * @param {Object} input
   * @returns {Object|null}
   */
  async function update(uuid, input) {
    const { data } = await mutateAsync({
      uuid,
      ...input,
      ...(Object.hasOwn(input, 'salary') ? { calculate_budgets: true } : {}),
    });
    return data?.updatePerson;
  }

  return update;
}
